export default {
  MAX_LENGTH_VERIFICATION_CODE: 6,
  MAX_LENGTH_PIN_CODE: 6,
  MAX_LENGTH_INPUT: 32,
  MAX_LENGTH_PASSWORD: 64,
  MAX_LENGTH_USERNAME: 64,
  MAX_LENGTH_EMAIL: 64,
  MAX_LENGTH_FULLNAME: 128,
  MAX_LENGTH_DESCRIPTION: 255,
  DEFAULT_SUCCESS_TIMEOUT: 4000,
  SNACKBAR_SUCCESS_TIMEOUT: 4000,
  SNACKBAR_ERROR_TIMEOUT: 2000,
  DEFAULT_LOADER_TIMEOUT: 1000,
  PROPERTIESVIEW_DEFAULT_MINIMIZED_SIZE: 35,
  SEARCHVIEW_DEFAULT_MINIMIZED_SIZE: 35,
  MAX_UPLOADED_AVATAR: 6900000,
  IMAGES_TYPES: [
    'image/bmp',
    'image/x-bmp',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/tiff',
    'image/vnd.wap.wbmp',
    'image/webp',
  ],
  PASSWORD_CONFIRMATION_TIMING: 1000,
  DIALOGS_HEADER_color: '#001935',
  BASE_ROUTES: {
    DASHBOARD: '/project/:projectId/snapshot/:snapshotId/dashboard/:dashboardId?',
    SNAPSHOT_VIEWER: '/project/:projectId/snapshot-viewer',
    SNAPSHOT_MANAGMENT: '/project/:projectId/snapshots',
    EXPLORER_BASE: '/project/:projectId/snapshot/:snapshotId/explorer',
    EXPLORER_GRAPH: 'artifact/:artifactId',
    LAYOUT: '/app',
    PROJECTOVERVIEW: '/project/:projectId/overview',
    PROJECTCONFIGURATION: '/project/:projectId/configuration',
    PROJECTLIST: '/projectlist',
    GLOBAL_FILTERS: '/project/:projectId/filters',
    LandingPage: '/',
    HOME: '/home',
    CALLBACK: '/callback',
    REPORTS: '/reports',
    MEMBERS: '/members',
    SETTINGS: '/settings',
    LOGOUT: '/logout',
    SIGNOUT: '/signOut',
    DASHBOARD_DETAILS_VIEWER:
      '/project/:projectId/snapshot/:snapshotId/dashboard/:metricsDetailsPath/series/:seriesName/totalCount/:totalServerItemsLength',
    HELP: '/help',
    CUSTOM_METRICS: '/project/:projectId/metrics',
    CUSTOM_METRIC: '/project/:projectId/metrics/:customMetricId',
  },
  ROUTES_NAME: {
    CALLBACK: 'callback',
    DASHBOARD: 'dashboard',
    SNAPSHOT_VIEWER: 'snapshot-viewer',
    EXPLORER: 'explorer',
    LAYOUT: 'layout',
    PROJECTOVERVIEW: 'overview',
    PROJECTLIST: 'projectlist',
    LandingPage: 'landingPage',
    HOME: 'home',
    LOGOUT: 'logout',
    SIGNOUT: 'signOut',
    DASHBOARD_DETAILS_VIEWER: 'dashboard-details-viewer',
    HELP: 'help',
    CUSTOM_METRICS: 'customMetrics',
    CUSTOM_METRIC: 'customMetric',
  },
  SNAPSHOT: {
    ALLOWED_FORMATS: ['.ytsnapshotzip'],
  },
  ERROR_HANDLING_DELAY: 1000,
  CONTACT: {
    EMAILS: {
      PRIVACY: 'privacy@yakinduIot.com',
    },
  },
  PAGES: {},
  HOMEPAGE: {
    LINKS: {},
  },
  BREADCRUMB_TYPES: {},
  BREAKPOINTS: {
    SCREEN_SIZE_992: 992,
    SCREEN_SIZE_991_98: 991.98,
    SCREEN_SIZE_768: 768,
    SCREEN_SIZE_767_98: 767.98,
    SCREEN_SIZE_576: 576,
    SCREEN_SIZE_575_98: 575.98,
    SCREEN_SIZE_470: 470,
    SCREEN_SIZE_469_98: 469.98,
  },
  FORM_TYPES: {
    INPUT: 'input',
    NUMBER: 'number',
    NUMBER_INPUT: 'number_input',
    TEXTAREA: 'textarea',
    SELECT: 'select',
    CHECKBOX: 'checkbox',
    WIZARD: 'wizard',
    FLAT_FORM: 'flat_form',
    VUE_SELECT: 'vue_select',
  },
  SNAPSHOT_SORT_LABEL: 'Sort by',
  NAME_FILTER_LABEL: 'Name',
  SORTING_OPTIONS: ['Name', 'Date'],
  ARTIFACTS: {
    PROVIDERS_ICONS: {
      'yt-adapter-c': 'c.gif',
      'yt-adapter-doors': 'doors.png',
      'yt-adapter-doorsng': 'doorsng.png',
      'yt-adapter-ea': 'ea.png',
      'yt-adapter-excel': 'excel.png',
      'yt-adapter-explorer': 'projectexplorer.gif',
      'yt-adapter-java': 'java.gif',
      'yt-adapter-mylyn': 'mylyn.gif',
      'yt-adapter-papyrus': 'papyrus.png',
      'yt-adapter-pdf': 'pdf.png',
      'yt-adapter-polarion': 'polarion.png',
      'yt-adapter-pror': 'pror.png',
      'yt-adapter-ptc': 'ptc.gif',
      'yt-adapter-rhapsody': 'rhapsody.png',
      'yt-adapter-sct': 'sct.png',
      'yt-adapter-sreme': 'sreme.gif',
      'yt-adapter-texteditor': 'texteditor.png',
      'yt-adapter-uml2': 'uml.gif',
      'yt-adapter-word': 'word.png',
      'yt-adapter-xml': 'xml.gif',
      'yt-adapter-xtext': 'xtext.gif',
      'yt-adapter-yakindu_model_viewer': 'modelviewer.png',
    },
    SEARCH: {
      PAGE_SIZE: 30,
    },
  },
  SORT_CRITERIA: ['Name', 'Created Date', 'Last Open'],
  CONTENT_TYPES: {
    YT_V1: 'application/vnd.yakindu.traceability.v1+json',
  },
  ALERT_VIEW: {
    VUE_ALERT_CLASS: 'white--text mt-0',
    COLOR: 'transparent',
    MIN_WIDTH: '60%',
    CLOSE_ALERT_LABEL: 'close',
    ALERT_TYPE: 'success',
  },
  EXPLORER: {
    SIDEBAR_RIGHT_WIDTH: 450,
    SIDEBAR_RIGHT_DEFAULT_HEIGHT: 712,
  },
  ICONS_MDI: {
    ICON_CHEVRON_DOWN: 'mdi-chevron-down',
    ICON_CHEVRON_UP: 'mdi-chevron-up',
    ICON_CHEVRON_RIGHT: 'mdi-chevron-right',
    ICON_CHEVRON_LEFT: 'mdi-chevron-left',

    ICON_MAP: 'mdi-map',
    ICON_DRAG: 'mdi-drag',
    ICON_CHECK: 'mdi-check',
    ICON_PLUS: 'mdi-plus',
    ICON_FILE_PLUS: 'mdi-file-plus',
    ICON_CLOSE: 'mdi-close',
    ICON_CONFIG: 'mdi-cog',

    ICON_STAR: 'mdi-star',
    ICON_STAR_OUTLINE: 'mdi-star-outline',

    ICON_MAGNIFY: 'mdi-magnify',
    ICON_MAGNIFY_PLUS: 'mdi-magnify-plus',
    ICON_MAGNIFY_MINUS: 'mdi-magnify-minus',
    ICON_MAGNIFY_EXPAND: 'mdi-magnify-expand',

    ICON_ARROW_EXPAND_ALL: 'mdi-arrow-expand-all',
    ICON_ARROW_COLLAPSE_ALL: 'mdi-arrow-collapse-all',
    ICON_ARROW_EXPAND_RIGHT: 'mdi-arrow-expand-right',
    ICON_ARROW_DOWN_DROP_CIRCLE: 'mdi-arrow-down-drop-circle',

    ICON_SAVE: 'mdi-content-save',
    ICON_EDIT: 'mdi-pencil',
    ICON_EDIT_OUTLINE: 'mdi-pencil-outline',
    ICON_DOTS_VERTICAL: 'mdi-dots-vertical',

    ICON_DELETE: 'mdi-delete',
    ICON_DELETE_EMPTY: 'mdi-delete-empty',
    ICON_DELETE_OUTLINE: 'mdi-delete-outline',

    ICON_DATABASE_SEARCH: 'mdi-database-search',
    ICON_FORMAT_LIST_BULLETED: 'mdi-format-list-bulleted',
    ICON_IMAGE_FILTER_CENTER_FOCUS: 'mdi-image-filter-center-focus',
    ICON_VIEW_LIST_OUTLINE: 'mdi-view-list-outline',
    ICON_CALENDAR_REMOVE_OUTLINE: 'mdi-calendar-remove-outline',
    ICON_LOGIN_VARIANT: 'mdi-login-variant',
    ICON_INFORMATION_OUTLINE: 'mdi-information-outline',
    ICON_ALPHA_S_BOX_OUTLINE: 'mdi-alpha-s-box-outline',
    ICON_ALERT_CIRCLE_OUTLINE: 'mdi-alert-circle-outline',
    ICON_TEXT_BOX_MULTIPLE: 'mdi-text-box-multiple',
    ICON_EMOTICON_HAPPY_OUTLINE: 'mdi-emoticon-happy-outline',
    ICON_HOME: 'mdi-home',
    ICON_FOLDER_MULTIPLE: 'mdi-folder-multiple',
    ICON_SETTINGS: 'mdi-cog',
    ICON_EYE: 'mdi-eye',
    ICON_EYE_OFF: 'mdi-eye-off',
    ICON_HELP: 'mdi-help',
    ICON_DOCUMENT_EDIT: 'mdi-file-document-edit-outline',
    ICON_CHART_BAR: 'mdi-chart-bar',
    ICON_CROSSHAIRS_GPS: 'mdi-crosshairs-gps',
    ICON_CONTENT_COPY: 'mdi-content-copy',

    ICON_CHECKBOX_MARKED: 'mdi-checkbox-marked',
    ICON_CHECKBOX_BLANK: 'mdi-checkbox-blank-outline',

    ICON_FILTER_OUTLINE: 'mdi-filter-outline',
  },
}
